import { Button } from '@codegouvfr/react-dsfr/Button';
import { useTextes } from '@common/config';
import { useCampagneFichiers } from '@common/hooks/campagne';
import {
  CampagneFichierType,
  EtablissementDeclarantDto,
  useGetAllOrganismeEtablissementsDeclarantsQuery,
} from '@common/services';
import { useDownloadCampagneFichierMutation } from '@common/services/campagne';
import { FileItem, getModalById } from '@common/ui';
import React from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { DownloadDocumentTravailModal } from './modals/DownloadDocumentTravailModal';

const downloadDocumentTravailModal = getModalById('download-document-travail-modal');

export const CampagneDocuments = ({ campagneId, organismeId }: CampagneDocumentsProps) => {
  const t = useTextes('ParcoursOfa', 'Campagne');

  const [downloadCampagneFichier] = useDownloadCampagneFichierMutation();

  const { filesMap } = useCampagneFichiers({ campagneId });

  const { data: etablissementsDeclarants = [] as EtablissementDeclarantDto[] } = useGetAllOrganismeEtablissementsDeclarantsQuery(
    { id: organismeId },
    { skip: !organismeId },
  );

  return (
    <div className={'px-8 py-8'}>

      <h6>{t['DETAIL_OFA_INFO_TEXTE1']}</h6>

      <div className={'flex flex-col gap-4'}>

        <Button onClick={() => downloadDocumentTravailModal.open()}>
          <MdOutlineFileDownload className={'h-6 w-6 mr-2'} />
          Télécharger un document de travail
        </Button>

        <DownloadDocumentTravailModal dsfrModal={downloadDocumentTravailModal}
                                      etablissements={etablissementsDeclarants} />

        {(!!filesMap.GUIDE_UTILISATEUR) && (
          <FileItem title="Guide utilisateur"
                    subType="Guide"
                    downloadOptions={{
                      fn: () => downloadCampagneFichier({
                        id: campagneId,
                        fichierType: CampagneFichierType.GUIDE_UTILISATEUR,
                      }),
                    }}
                    dateModification={filesMap.GUIDE_UTILISATEUR.dateModification}
                    fileBackgroundColor={'#4AD0F1'} />
        )}

        {(!!filesMap.NOTICE) && (
          <FileItem title="Notice"
                    subType="Notice"
                    downloadOptions={{
                      fn: () => downloadCampagneFichier({
                        id: campagneId,
                        fichierType: CampagneFichierType.NOTICE,
                      }),
                    }}
                    dateModification={filesMap.NOTICE.dateModification}
                    fileBackgroundColor={'#4AD0F1'} />
        )}
      </div>
    </div>
  );
};

interface CampagneDocumentsProps {
  campagneId: number;
  organismeId: number;
}